class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.facetForm = this.querySelector('form');
    this.facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    // this.facetForm.addEventListener('submit', this.onSubmitHandler.bind(this));

    // const facetOpener = this.querySelector('.facets-top__opener')
    // facetOpener.addEventListener('click', this.handleFacetOpening.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state && event.state.url ? event.state.url : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(url, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = url;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      
      const section_url = url.indexOf('?') != -1 ? `${url}&section_id=${section.section}&facets` : `${url}?section_id=${section.section}&facets`;
      // `${baseUrl == "" ? window.location.pathname : baseUrl}/${tagFilters}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === section_url;
 
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(section_url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(url);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderBreadcrumbs(html);
        FacetFiltersForm.renderProductCount(html);

      // 👇 Scroll to top after rendering
      window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderBreadcrumbs(html);
    FacetFiltersForm.renderProductCount(html);

  // 👇 Scroll to top after rendering
  window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderBreadcrumbs(html){
    return //todo make breadcrumb section use snipped and hide within facets for re render
    const bcrumbs = new DOMParser().parseFromString(html, 'text/html').querySelector('.hidden-bcrumbs .breadcrumbs').innerHTML
    const container = document.querySelector('.breadcrumbs');

    container.innerHTML = bcrumbs
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const jsFilter = event ? event.target.closest('.js-filter') : undefined;

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #FacetTopFiltersForm .js-filter');

    const facetFiltersForm = parsedHTML.querySelectorAll('facet-filters-form');
    
    Array.from(facetFiltersForm).forEach(facet => {
      let form = facet.querySelector('form')
      if(!form) return
      let id = form.id
      if(id.length == 0) return
      var current_facet = document.querySelector(`#${id}`).closest('facet-filters-form')

      if(current_facet){
        //replace current facet with new one, being a web component, it will rebind events
        current_facet.outerHTML = facet.outerHTML
      }
    })

    return

    const matchesIndex = (element) => {
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = jsFilter && jsFilter.dataset.type == "tag" ? facetDetailsElements : Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      var target_filter = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`)
      if(!target_filter) return

      if(jsFilter && jsFilter.dataset.index == element.dataset.index){
        target_filter.open = true;
      }
      target_filter.outerHTML = element.outerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(url) {
    history.pushState({ url }, '', url);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  createTagParams(form) {
    const tag_inputs = form.querySelectorAll('.tag-filter:checked')
    const tag_array = []

    if(!tag_inputs[0]) return

    tag_inputs.forEach(filter => {
      var tag = filter.dataset.name
      if(!tag_array.includes(tag)) {
        tag_array.push(tag)
      } else {
        console.log("FOUND DOUBLE UP")
      }
    })

    return tag_array.join('+')
  }

  createSearchTagParams(form) {
    
    const tag_inputs = form.querySelectorAll('.tag-filter:checked')
    const tag_array = []

    if(!tag_inputs[0]) return

    tag_inputs.forEach(filter => {
      var tag = filter.dataset.name
      if(!tag_array.includes(tag)) {
        tag_array.push(`tag:${tag}`)
      } else {
        console.log("FOUND DOUBLE UP")
      }
    })

    return tag_array.join(' ')
  }

  onSubmitForm(url, event) {
    FacetFiltersForm.renderPage(url, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    const forms = [];
    var tag_filters = []
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
    
    if(isMobile ){
      let form = event.target.closest('form')
      forms.push(this.createSearchParams(form));

      //tag filters treated differently, change url path
      var form_tags = this.dataset.baseUrl == '/search' ? this.createSearchTagParams(form) : this.createTagParams(form)

      if(form_tags ) {
        tag_filters.push(form_tags)
      }
    } else {
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetTopFiltersForm' || form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {

          forms.push(this.createSearchParams(form));

          //tag filters treated differently, change url path
          var form_tags = this.dataset.baseUrl == '/search' ? this.createSearchTagParams(form) : this.createTagParams(form)

          if(form_tags ) {
            tag_filters.push(form_tags)
          }
        }
      });
    }

    var unique = [...new Set(tag_filters)];

    var search_query = ''

    if(this.dataset.baseUrl == '/search'){
      //search tags need to use q to sort tags
      var form_string = forms.join('&')
      const params = Object.fromEntries(new URLSearchParams(form_string));

      //check for current params

      if(params.q){
        params.q = params.q + ' ' + tag_filters.join(' ')
      }

      // params.q = query_array.join(' ')

      search_query = `?${new URLSearchParams(params).toString()}`

    } else {
      //collection filters
      search_query = `${unique ? unique.join('+') : ''}?${forms.join('&')}`
    }
    
    const url = `${this.dataset.baseUrl == "" ? window.location.pathname.substring(0, window.location.pathname.length - 1) : this.dataset.baseUrl}/${search_query}`

    this.onSubmitForm(url, event)

    /*
      Need to have both tag filters and new filters
      Tag filters add onto url (/collections/all/tag1+tag2)
      New filters add url parameter (/collections/all?new_filter=value?new_filter2=value)

      Current implementation creates formData of entire form, converts to URLSearchParams and adds to forms array

      Can create new FormData and .append values depending if they are new or old

      onSubmitForm has extra string for old tags

        forms [
          [ NEW ],
          [ OLD ]
        ]
      
      DRAWBACK have to iterate over all inputs, put in correct form data obj

      OR

      treat tag filters separately by having them as inputs with no names (data-name),
      iterate over and create separate string
        More efficient,
    */
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();
    var tag_component, search_params

    if(event.currentTarget.classList.contains('active-facets__button--tag')){
      var { tag, current } = event.currentTarget.dataset
      var current_array = JSON.parse(current)
      tag_component = current_array.filter(item => item !== tag)
      search_params = window.location.search == "" ? "" : window.location.search.slice(window.location.search.indexOf('?') +1); //use js as liquid does not provide search param, ? added within render page
    } else {
      //need to get current tag filters to be maintained
      const current_tag_filters = this.querySelectorAll('.active-facets__button--tag')
      tag_component = Array.from(current_tag_filters).map(tag_el => {
        return tag_el.dataset.tag
      })
      
      search_params = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    }

    const url = `${this.dataset.baseUrl == "" ? window.location.pathname : this.dataset.baseUrl}/${tag_component.join('+')}?${search_params}`

    FacetFiltersForm.renderPage(url, event);
    //Need to pass through tagFilters and baseUrl here. How to get current filters minus this one?

  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.indexOf('q=') != -1 ? window.location.search : window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class CollectionColumns extends HTMLElement {
  constructor() {
    super();

    this.collectionGrid = document.querySelector('#product-grid')
    this.deviceIsMobile = window.matchMedia('(max-width: 749px)')

    if(!this.collectionGrid) return

    this.addEventListener('click', this.handleColumnChange.bind(this))
  }

  handleColumnChange(event) {
    if(!event.target.closest('.facets-column')) return

    const target = event.target.closest('.facets-column')

    const desired_columns = target.dataset.cols
    const current_classes = [...this.collectionGrid.classList]
    var responsive_class = 'desktop'

    //set class based off current screen width, leaving other class 

    if(this.deviceIsMobile.matches){
      //mobile browser
      responsive_class = 'tablet-down'
      let initial_mobile_el = this.querySelector('.active--init-mb')
      if(initial_mobile_el) initial_mobile_el.classList.remove('active--init-mb')
    } else {
      //desktop
      let initial_desktop_el = this.querySelector('.active--init-dt')
      if(initial_desktop_el) initial_desktop_el.classList.remove('active--init-dt')
    }

    if(target.classList.contains('active')) return
    this.setActive(target)

    var column_regex = new RegExp(`^grid--.*-${responsive_class}$`)

    for (let i = 0; i < current_classes.length; i++) {
      const current_class = current_classes[i];
      if(column_regex.test(current_class)){
        this.collectionGrid.classList.remove(current_class)
        this.collectionGrid.classList.add(`grid--${desired_columns}-col-${responsive_class}`)
        break
      }
    }
  }

  setActive(item) {
    const current_active = this.querySelector('.active')
    if(current_active) {
      current_active.classList.remove('active')
    }
    item.classList.add('active')
  }
}

customElements.define('collection-columns', CollectionColumns)

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
